import { API } from '@/config/constants';
import { offlineMediaLabel } from '@/utils/mediaPresentation';

export function cloudProductPhotoUrl(productId, size, updatedAt) {
  const sizeParam = size ? `size=${encodeURIComponent(size)}&` : '';
  // Stable policy revision bypasses cached responses from before Vary: Origin.
  // Keep normal caching and the existing replacement timestamp thereafter.
  return `${API}/products/${encodeURIComponent(productId)}/photo?${sizeParam}v=${encodeURIComponent(updatedAt || '')}&cache_policy=origin-v1`;
}

/**
 * Describe the selected catalog reference image without confusing H1's safe
 * configured facts with an image that can actually be opened offline.
 */
export function productReferencePresentation(resolvedProduct) {
  const product = resolvedProduct?.product;
  if (!product?.id) {
    return {
      configured: false,
      protectedLocal: false,
      requestKey: null,
      requestUrl: null,
    };
  }

  const size = resolvedProduct.size_label || '';
  const hasProtectedFacts = (
    Object.prototype.hasOwnProperty.call(product, 'reference_image_configured')
    || Object.prototype.hasOwnProperty.call(product, 'size_reference_photo_labels')
  );
  if (hasProtectedFacts) {
    const configuredSizes = Array.isArray(product.size_reference_photo_labels)
      ? product.size_reference_photo_labels
      : [];
    const configured = Boolean(
      (size && configuredSizes.includes(size))
      || product.reference_image_configured,
    );
    const sizeParam = size ? `?size=${encodeURIComponent(size)}` : '';
    return {
      configured,
      protectedLocal: true,
      requestKey: configured
        ? `protected-product:${product.id}:${size || 'default'}:${product.updated_at || ''}`
        : null,
      requestUrl: configured
        ? `${API}/desktop/product-media/${encodeURIComponent(product.id)}${sizeParam}`
        : null,
    };
  }

  const configured = Boolean(
    (size && product.size_photos?.[size])
    || product.reference_photo_url,
  );
  if (!configured) {
    return {
      configured: false,
      protectedLocal: false,
      requestKey: null,
      requestUrl: null,
    };
  }
  return {
    configured: true,
    protectedLocal: false,
    requestKey: `cloud-product:${product.id}:${size || 'default'}:${product.updated_at || ''}`,
    requestUrl: cloudProductPhotoUrl(product.id, size, product.updated_at),
  };
}


export function productReferenceMediaLabel(reference, emptyLabel) {
  if (!reference?.configured) return emptyLabel;
  if (reference.protectedLocal) return offlineMediaLabel(reference.mediaResult);
  if (reference.mediaResult?.state === 'loading') return 'Loading reference image';
  return 'Unable to display reference image';
}
